import React from "react";
import { Row } from "@tanstack/react-table";
import { FormCheckbox } from "../forms/FormCheckbox/FormCheckbox";

interface ViewTableCheckboxCellProps<TData> {
    readonly row: Row<TData>;
}

export function ViewTableCheckboxCell<TData>({
    row,
}: ViewTableCheckboxCellProps<TData>) {
    return (
        <FormCheckbox
            value={row.id}
            isChecked={row.getIsSelected()}
            disabled={!row.getCanSelect()}
            handleChangeEvent={row.getToggleSelectedHandler()}
            small
            preventClickPropagation
        />
    );
}
